// extracted by mini-css-extract-plugin
export default {"stripeStatusBadge":"StripeStatusBadge_stripeStatusBadge__3sF8I"};